export default __webpack_public_path__ + "static/media/sd-info-icon.e3187d23.svg";